import { defineStore } from 'pinia'

const domain = process.env.VUE_APP_OP_DOMAIN

type OceanResponse =
	| {
			success: true
			data: { expired_at: number; timestamp: number; id: string }
	  }
	| {
			success: false
			code: string
	  }

export const useOceanStore = defineStore('ocean', {
	state: () => {
		return {
			isOcean: false as boolean,
			id: '' as string,
			errorCode: '' as string
		}
	},
	actions: {
		async fetchOceanStatus() {
			const search = window.location.search
			if (!search.includes('signature') || !search.includes('timestamp')) {
				return
			}
			try {
				const response = await fetch(`https://labels.${domain}/ocean/validate${search}`)
				const data: OceanResponse = await response.json()
				if (data.success) {
					this.isOcean = true
					this.id = data.data.id
					const ttl = Math.floor(data.data.expired_at - Date.now() / 1000)

					setTimeout(() => {
						document.cookie = `experience=; path=/; domain=.${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT`
						location.reload()
					}, ttl * 1000)
				} else {
					this.errorCode = data.code
				}
			} catch (error) {
				console.error('Fetch error:', error)
			}
		}
	}
})
